import { Grid, Card, CardContent, Typography, Avatar } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useState } from "react";
import { DialogFile } from "src/components/dialog-file";

const getIcon = (documentType) => {
    switch (documentType) {
        case 1: // PDF
            return <PictureAsPdfIcon fontSize="large" />
        case 2: // Text
            return <DescriptionIcon fontSize="large" />
        case 3: // Word
            return <ImageIcon fontSize="large" />
        case 4: // Excel
            return <DescriptionIcon sx={{ color: 'green' }} />
        case 5: // Image
            return <ImageIcon color="primary" />
        case 6: // Markdown
            return <DescriptionIcon sx={{ color: '#6f42c1' }} />
        case 7: // HTML
            return <DescriptionIcon sx={{ color: '#e34c26' }} />
        case 8: // CSV
            return <DescriptionIcon sx={{ color: 'green' }} />
        default:
            return <InsertDriveFileIcon fontSize="large" />
    }
}

const getDocumentTypeName = (documentType) => {
    switch (documentType) {
        case 1:
            return "PDF"
        case 2:
            return "Documento"
        case 3:
            return "Imagem"
        case 4:
            return "Excel"
        case 5:
            return "Image"
        case 6:
            return "Markdown"
        case 7:
            return "HTML"
        case 8:
            return "CSV"
        default:
            return "Desconhecido"
    }
}

export const FileCard = ({ file, onOpenFile, onDelete, intl }) => {

    const [open, setOpen] = useState(false)

    return (
        <>
            <Grid item xs={12} sm={4} md={4}>
                <Card
                    onClick={() => setOpen(true)}
                    sx={{
                        border: "1px solid #ddd",
                        borderRadius: "12px",
                        padding: "12px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        cursor: "pointer",
                    }}
                >
                    <Avatar sx={{ width: 56, height: 56, mb: 1 }}>
                        {getIcon(file.documenttype)}
                    </Avatar>

                    <CardContent sx={{ p: 0, pb: '0 !important', width: '100%' }}>
                        <Typography
                            variant="body1"
                            noWrap
                            sx={{
                                fontWeight: 500,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                            }}
                        >
                            {file.filename}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            {getDocumentTypeName(file.documenttype)}
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>

            <DialogFile file={file} intl={intl} open={open} onClose={() => setOpen(false)} onOpenFile={onOpenFile} onDelete={onDelete} />
        </>
    )
}

export default FileCard